<template>
  <div :style="`width:100%;height:${height};`"  v-if="device==='desktop'">
    <webview :style="`width:100%;height:${height};`" ref="notebook"
      :src="src" />
  </div>
  <div :style="`width:100%;height:${height};`" v-else>
     <iframe :style="`width:100%;height:${height};border:none;`"
    :src="src" />
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    height: {
      type: String,
      default: '100%',
    },
    me: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      file: {},
      service: 'process.env.VUE_APP_NOTEBOOK_SERVICE',
      device: 'process.env.VUE_APP_DEVICE',
      src: '',
    };
  },

  watch: {
    id(val) {
      this.getFileInfoByIds();
    },
  },
  methods: {
    getFileInfoByIds() {
      
      this.$api.alliance.getFileInfoByIds([this.id]).then((res) => {
        this.file = res.fileList[0];
        this.src = encodeURI(`${this.service}/notebook?noteBookPath=${this.file.filePath}
        &noteBookName=${this.file.name}&fileId=${this.file.fileId}&parentId=${this.file.parentId}&type=line&edit=false`);
      //  console.log((`${this.service}/notebook?noteBookPath=${this.file.filePath}&noteBookName=${this.file.name}&userId=${this.me ? this.user.id : '0'}&fileId=${this.file.fileId}&parentId=${this.file.parentId}&type=line&edit=false`))
       // this.src = encodeURI(`http://alpha.atrader.com:42088/notebook?noteBookPath=&noteBookName=%E6%88%91%E7%9A%84%E6%B5%8B%E8%AF%95%E5%AE%9E%E9%AA%8C.ipynb&userId=38792&fileId=3678&parentId=0&type=line&edit=false`);
       });
    },
  },
  mounted() {
    this.getFileInfoByIds();
  },
};
</script>

<style>

</style>